"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HTTP_METHODS = void 0;
var HTTP_METHODS = Object.freeze({
  GET: "GET",
  POST: "POST"
});
exports.HTTP_METHODS = HTTP_METHODS;